import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import '../styles/main.scss'


const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Slow Ventures"
      meta={[
        { name: 'description', content: 'Slow Ventures', },
        { name: 'keywords', content: '', },
        { name: 'og:description',  content: "Slow invests in entrepreneurs and inventors central to the technology industry and those who are leading on the edges of science, society, and culture." ,},
        { name: 'og:title',  content: 'Slow Ventures', },
        { name: 'og:url',  content: 'https://slowventures.com', },
        { name: 'og:image', content: "http://slowventures.com/assets/images/social.jpg", },
      ]}
    />


    <div>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js